module.exports = __webpack_public_path__ + "img/profession_page04_down_arrow.629a7512.png";